const ResultSet = {
    subtitle: {
        English: 'Here\'s what you\'re doing well:',
        German: 'Hier sehen Sie, was bei Ihnen gut läuft:',
        French: 'Vos points forts :',
        Russian: 'Это у Вас получается хорошо:',
        Turkish: 'İyi yaptığınız şeyler:',
        Italian: 'Ecco in cosa stai andando bene:',
        Spanish: 'Esto es lo que está haciendo bien:',
        PortugueseBR: 'Veja onde sua organização vai bem:',
        SpanishLAD: 'Esto es lo que estás haciendo bien:'
    },
    titleG: {
        English: 'Results summary',
        German: 'Sie stehen auf einer Stufe mit den besten Finanzorganisationen:',
        French: 'Vous êtes au niveau des services financiers les plus performants :',
        Russian: 'Вы на равных с лучшими финансовыми организациями:',
        Turkish: 'En iyi finans kuruluşlarıyla başa baş gidiyorsunuz:',
        Italian: 'Sei al passo con le migliori organizzazioni di amministrazione, finanza e controllo.',
        Spanish: 'Está a la par de las mejores empresas financieras:',
        PortugueseBR: 'Você está no mesmo nível das melhores organizações financeiras:',
        SpanishLAD: 'Estás a la altura de las mejores organizaciones financieras:'
    },
    titleM: {
        English: 'Results summary',
        German: 'Hier sehen Sie, was bei Ihnen gut läuft:',
        French: 'Vos points forts :',
        Russian: 'Это у Вас получается хорошо:',
        Turkish: 'İyi yaptığınız şeyler:',
        Italian: 'Ecco in cosa stai andando bene:',
        Spanish: 'Esto es lo que está haciendo bien:',
        PortugueseBR: 'Veja onde sua organização vai bem:',
        SpanishLAD: 'Esto es lo que estás haciendo bien:'
    },
    titleB: {
        English: 'Results summary',
        German: 'Das sind die Bereiche mit Verbesserungspotenzial:',
        French: 'Les points qui peuvent être améliorés :',
        Russian: 'Моменты, над которыми стоит поработать еще:',
        Turkish: 'Bazı iyileştirme fırsatları aşağıda verilmiştir:',
        Italian: 'Ecco alcune opportunità di miglioramento:',
        Spanish: 'Estas son algunas de las oportunidades de mejora:',
        PortugueseBR: 'Aqui estão algumas oportunidades de melhoria:',
        SpanishLAD: 'Aquí te presentamos algunas oportunidades para mejorar:'
    },
    btn1: {
        English: 'Request demo',
        German: 'Oracle Cloud Demo anfordern',        
        French: 'Demander une démo d\'Oracle Cloud',
        Russian: 'Запросить демонстрацию Oracle Cloud ',
        Turkish: 'Oracle Cloud Demo isteyin',
        Italian: 'Richiedi la demo di Oracle Cloud',
        Spanish: 'Solicite la demostración de Oracle Cloud ',
        PortugueseBR: 'Solicite uma demonstração do Oracle Cloud',
        SpanishLAD: 'Solicite la demostración de Oracle Cloud '
    },
    btn2: {
        English: 'Access my report',
        German: 'Link zu Ihrem Bericht',
        French: 'Lien vers votre rapport',
        Russian: 'Ссылка на ваш отчет ',
        Turkish: 'Raporunuza ulaşın',
        Italian: 'Link al report',
        Spanish: 'Enlace a su informe',
        PortugueseBR: 'Link para seu relatório ',
        SpanishLAD: 'Enlace a su informe'
    },
    legend1: {
        English: 'Your rating',
        German: 'Ihre Bewertung',
        French: 'Votre score',
        Russian: 'Ваша оценка',
        Turkish: 'Puanınız',
        Italian: 'Il tuo punteggio',
        Spanish: 'Su puntuación',
        PortugueseBR: 'Sua classificação',
        SpanishLAD: 'Tu calificación'
    },
    legend2: {
        English: 'Best in class',
        German: 'Erstklassig',
        French: 'Le meilleur du secteur',
        Russian: 'Лучший в своем классе',
        Turkish: 'Sınıfının en iyisi',
        Italian: 'Il migliore della categoria',
        Spanish: 'Categoría superior',
        PortugueseBR: 'Melhor na categoria',
        SpanishLAD: 'Mejor de su clase'
    },
    report: {
        English: 'REPORT',
        German: 'BERICHT',
        French: 'RAPPORT',
        Russian: 'ОТЧЕТ',
        Turkish: 'RAPOR',
        Italian: 'REPORT',
        Spanish: 'INFORME',
        PortugueseBR: 'RELATÓRIO',
        SpanishLAD: 'INFORME'
    },
    footer1: {
        English: 'Privacy/Do Not Sell My Info',
        German: 'Nutzungsbedingungen und Datenschutz',
        French: "Conditions d'utilisation et confidentialité",
        Russian: 'Условия использования и конфиденциальность',
        Turkish: 'Kullanım Koşulları Ve Gizlilik',
        Italian: "Termini d'uso e privacy",
        Spanish: 'Términos de uso y privacidad',
        PortugueseBR: 'Termos de Uso e Privacidade',
        SpanishLAD: 'Términos de uso y privacidad'
    },
    footer2: {
        English: 'Ad Choices',
        German: 'Anzeigenauswahl',
        French: 'Choix des publicités',
        Russian: 'Реклама',
        Turkish: 'Reklam Seçimleri',
        Italian: 'Scelte pubblicitarie',
        Spanish: 'Opciones de publicidad',
        PortugueseBR: 'Adicionar Opções',
        SpanishLAD: 'Opciones para los anuncios'
    },
    copyright: {
        English: 'https://www.oracle.com/legal/privacy/',
        German: 'https://www.oracle.com/de/legal/copyright.html',
        French: "https://www.oracle.com/fr/legal/copyright.html",
        Russian: 'https://www.oracle.com/ru/legal/copyright.html',
        Turkish: 'https://www.oracle.com/tr/legal/copyright.html',
        Italian: "https://www.oracle.com/it/legal/copyright.html",
        Spanish: 'https://www.oracle.com/es/legal/copyright.html',
        PortugueseBR: 'https://www.oracle.com/br/legal/copyright.html',
        SpanishLAD: 'https://www.oracle.com/lad/legal/copyright.html'
    },
    footerLink1: {
        English: 'https://www.oracle.com/legal/privacy/',
        German: 'https://www.oracle.com/de/legal/privacy/',
        French: "https://www.oracle.com/fr/legal/privacy/",
        Russian: 'https://www.oracle.com/ru/legal/privacy/',
        Turkish: 'https://www.oracle.com/tr/legal/privacy/',
        Italian: "https://www.oracle.com/it/legal/privacy/",
        Spanish: 'https://www.oracle.com/es/legal/privacy/',
        PortugueseBR: 'https://www.oracle.com/br/legal/privacy/',
        SpanishLAD: 'https://www.oracle.com/lad/legal/privacy/'
    },
    footerLink2: {
        English: 'https://www.oracle.com/legal/privacy/privacy-policy.html#advertising',
        German: 'https://www.oracle.com/de/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13',
        French: "https://www.oracle.com/fr/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
        Russian: 'https://www.oracle.com/ru/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13',
        Turkish: 'https://www.oracle.com/tr/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13',
        Italian: "https://www.oracle.com/it/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13",
        Spanish: 'https://www.oracle.com/es/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13',
        PortugueseBR: 'https://www.oracle.com/br/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13',
        SpanishLAD: 'https://www.oracle.com/lad/legal/privacy/marketing-cloud-data-cloud-privacy-policy.html#13'
    },
    copied: {
        English: 'Copied',
        German: 'Kopiert',
        French: 'Copié',
        Russian: 'Скопировано',
        Turkish: 'Kopyalandı',
        Italian: 'Copiato',
        Spanish: 'Copiado',
        PortugueseBR: 'Copiado',
        SpanishLAD: 'Copiado'
    },
    cc: {
        English: 'uk',
        German: 'de',
        French: 'fr',
        Russian: 'ru',
        Turkish: 'tr',
        Italian: 'it',
        Spanish: 'es',
        PortugueseBR: 'br',
        SpanishLAD: 'lad'
    }
};

export default ResultSet;
